<div class="component">

    dev tools here

</div>